import { langSlice } from "./lang";
import userSlice from "./user";
import { combineReducers } from "redux";
import adminSlice from "./admin";
import notificationSlice from "./notification";

export const rootReducer = combineReducers({
  lang: langSlice.reducer,
  user: userSlice,
  admin: adminSlice,
  notification: notificationSlice,
});
